import React from 'react';
import PropTypes from 'prop-types';

import CreateWizardLayout from '../../../../../components/CreateWizardLayout';
import AlbumFolderJoinCode from '../../../AlbumFolderSettings/AlbumFolderJoinCode';

const propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  touched: PropTypes.object,
};

const FreemiumEventCreateJoinCodeStep = ({
  values,
  errors,
  handleChange,
  handleBlur,
  touched,
}) => {
  return (
    <CreateWizardLayout.Wrapper>
      <CreateWizardLayout.Content>
        <p className="text-center text-bold">
          Your guests will be able to text your code to{' '}
          <span className="text-primary">735-343</span>
          <br className="d-none d-md-inline" /> to join your event.
        </p>
        <AlbumFolderJoinCode
          values={values}
          errors={errors}
          handleChange={handleChange}
          handleBlur={handleBlur}
          touched={touched}
          skippable={false}
          sampleJoinCode="SaraAndBill"
        />
      </CreateWizardLayout.Content>
    </CreateWizardLayout.Wrapper>
  );
};

FreemiumEventCreateJoinCodeStep.propTypes = propTypes;

export default FreemiumEventCreateJoinCodeStep;
